<div class="avatar items-start" *ngIf="(profilePicture$ | ngrxPush)?.loading">
    <div class="spinner spinner-primary {{ avatarClasses }}"></div>
</div>

<div class="avatar items-start" *ngIf="(profilePicture$ | ngrxPush)?.url && !(profilePicture$ | ngrxPush)?.loading">
    <div class="{{ avatarClasses }} rounded-lg">
        <img [src]="(profilePicture$ | ngrxPush)?.url" />
    </div>
</div>

<div class="avatar placeholder items-start" *ngIf="!(profilePicture$ | ngrxPush)?.url && !(profilePicture$ | ngrxPush)?.loading">
    <div class="{{ avatarClasses }} rounded-lg bg-neutral text-neutral-content">
        <span class="uppercase">{{ initials }}</span>
    </div>
</div>
